import { IInvokerStrategy, TInvokerStrategySettle } from '../TInvoker';

const all: IInvokerStrategy = (task) => ({
    runNext: !task.result?.error,
    settle: task.result?.error
        ? TInvokerStrategySettle.error
        : TInvokerStrategySettle.aggregateSuccessful,
});

const any: IInvokerStrategy = (task) => ({
    runNext: !!task.result?.error,
    settle: task.result?.error
        ? TInvokerStrategySettle.aggregateError
        : TInvokerStrategySettle.successful,
});

const allSettled: IInvokerStrategy = () => ({
    runNext: true,
    settle: TInvokerStrategySettle.all,
});

const race: IInvokerStrategy = (task) => ({
    runNext: false,
    settle: task.result?.error
        ? TInvokerStrategySettle.error
        : TInvokerStrategySettle.successful,
});

export default {
    all, allSettled, any, race,
};

export {
    all, allSettled, any, race,
};
